export class ControlStatus {
  static none = 0;
  static approved = 1;
  static unapproved = 2;
}
